import React from 'react'
import { Content, Measuring, Unit } from './styles'
import { BehaviorCard } from '~/components/behaviors/BehaviorCard'
import { transformDate } from '~/utils'
import { IBehavior } from '~/interfaces'

interface IProps {
  behavior: IBehavior | undefined
}

export const BloodPressure = ({ behavior }: IProps): JSX.Element => {
  if (!behavior) return <></>
  if (behavior.type !== 'Pressão Arterial') return <></>

  const { type, endDate, properties } = behavior
  const datetimeLastUpdate = transformDate({ date: endDate, withHourAndMinute: false, dateFormat: 'dd/MM HH:mm' })

  const systolicPressure = properties.find(p => p.type === 'Pressão Sistólica')?.value
  const diastolicPressure = properties.find(p => p.type === 'Pressão Diastólica')?.value
  const unit = properties.find(p => p.type === 'Pressão Sistólica')?.unit
  const bloodPressureMeasuring = `${systolicPressure}x${diastolicPressure}`

  return (
    <>
      <BehaviorCard title={type} iconName="behaviorHeart" time={datetimeLastUpdate}>
        <Content>
          <Measuring>{bloodPressureMeasuring}</Measuring>
          <Unit>{unit}</Unit>
        </Content>
      </BehaviorCard>
    </>
  )
}
